import { render, staticRenderFns } from "./AddSource.vue?vue&type=template&id=b2f72dc8&scoped=true"
import script from "./AddSource.vue?vue&type=script&lang=js"
export * from "./AddSource.vue?vue&type=script&lang=js"
import style0 from "./AddSource.vue?vue&type=style&index=0&id=b2f72dc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f72dc8",
  null
  
)

export default component.exports